<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xl-8" style="padding-right: 15px;padding-left:0px">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left"># {{case.CaseNumber}}</span>
                <span style="float:right">{{case.CreatedDate | date :'medium'}}</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="container">
                <div class="row t30-padding">
                    <div *ngIf="!isCaseLoaded" class="spinner-border text-info" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="isCaseLoaded" class="col-md-12 col-sm-12 no-padding">
                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-left: 5px;padding-bottom: 10px;">
                            <small>
                                <span *ngIf="case.Status == 'Escalated'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{case.Status}}</span>
                                <span *ngIf="case.Status == 'New'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{case.Status}}</span>
                                <span *ngIf="case.Status == 'Open'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{case.Status}}</span>
                                <span *ngIf="case.Status == 'On Hold'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">{{case.Status}}</span>
                                <span *ngIf="case.Status != 'Escalated' && case.Status != 'New' && case.Status != 'Open' && case.Status != 'On Hold'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">{{case.Status}}</span>
                            </small>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-top:10px">
                            <h4 style="margin-left:5px">{{case.Subject}}</h4>
                            <pre style="white-space: pre-wrap; background-color: white" [innerHTML]="case.Description"></pre>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                            <div class="row" style="padding-bottom: 10px; padding-top: 10px">
                                <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px;">
                                    <b>Attachments</b>
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-6" *ngFor="let item of caseAttachments">
                                    <div class="file-body" style="padding-bottom: 5px">
                                        <i style="font-size: 18px !important;">
                                            <span class="fa fa-file"></span>
                                            <a style="    padding-left: 10px;cursor: pointer; font-size: 15px !important;"
                                               (click)="downloadAttachment(item.href,item.Name)">{{item.Name}}</a>
                                        </i>
                                    </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="caseAttachments.length == 0">
                                    No attachment(s) found
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Case Replies</span>
            </h6>
        </div>
        <div class="block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="container">
                <div class="row t30-padding">
                    <div *ngIf="!isCaseLoaded && !isRepliesLoaded" class="spinner-border text-info" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="isCaseLoaded && isRepliesLoaded" class="col-md-12 col-sm-12 no-padding">
                        <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                            <mat-accordion class="example-headers-align">
                                <mat-expansion-panel style="margin-bottom:10px;" *ngFor="let item of caseActivityHistory; let i = index">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                                <span>{{i + 1}}: </span>
                                                <img style="height: 30px;width: 30px; border-radius: 50%" class="message-avatar" src="{{item.OwnerImg}}" alt="">
                                                <a style="padding-left:5px; font-size:14px;color:#252525"> {{item.OwnerName}} </a>
                                                <small style="float: right; opacity:.5"> {{item.CreatedDate | date:'medium'}} </small>
                                            </div>

                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <pre style="white-space: pre-wrap; background-color: transparent; font-size: 14px !important; color: #252525" [innerHTML]="item.Description"></pre>

                                </mat-expansion-panel>

                            </mat-accordion>
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                            <textarea placeholder="Write your message here..." style="padding:10px !important;    font-size: 14px !important; margin-bottom: 10px;   border-color: lightgrey;border-bottom: 2px solid #00A6B6;width:100%;height:100px" class="summernote" [(ngModel)]="activityHistory.Description"></textarea>


                            <div class="col-md-12">
                                <div class="form-group">
                                    <div clas="col-md-3" style="padding-top:15px ">
                                        <div class="form-row">
                                            <input type="file" (change)="filesSelect($event)" name="file" id="file" class="inputfile" />
                                            <label for="file">Add Attachments <i class="fa fa-file"></i></label>
                                        </div>

                                    </div>
                                    <table class="table" *ngIf="files.length > 0">
                                        <thead>
                                            <tr>
                                                <th width="50%">Name</th>
                                                <!--<th>Size</th>-->
                                                <th>Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of files;let i = index">
                                                <td><strong>{{ item.name }}</strong></td>
                                                <!--<td  nowrap>{{ item.size/1024/1024|number:2 }} MB</td>-->
                                                <td nowrap>
                                                    <a style="cursor:pointer" (click)="removeFile(i)">
                                                        <span class="fa fa-trash-o"></span> Remove
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>




                            <div class="col-md-12" style="padding-top:5px; text-align: right; ">
                                <button style="float:right" [disabled]="btnSendDisabled" (click)="sendActivityHistory()" class="btn mygistec-main-btn">{{btnSend}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <app-follower-box [title]="'Share support case'" [relatedTo]="'support'" [relatedId]="id"></app-follower-box>
        <div class="row" style="margin-bottom:15px !important">
            <!--Request details-->
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Request details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div *ngIf="!isCaseLoaded" class="spinner-border text-info" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div *ngIf="isCaseLoaded" class="row small-section-content">
                    <div class="col-xl-12 no-padding" style="margin-top:0px">
                        <div style="font-weight: bold;">Support Type</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.SupportType}}</p>
                    </div>
                    <div *ngIf="case.IsAdvancedSupport" class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Severity Level</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.SeverityLevel}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Requester name</div>
                        <div style="margin-top:10px">
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd;">{{case.Contact.Name}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Requester account</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Account.Name}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Responsible support analyst</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Owner.Name}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Request origin</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Origin}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Created date</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.CreatedDate | date : 'medium'}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Last Modified date</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.LastModifiedDate | date : 'medium'}}</p>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Product details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div *ngIf="!isCaseLoaded" class="spinner-border text-info" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div *ngIf="isCaseLoaded" class="row small-section-content">
                    <div class="col-xl-12 no-padding" style="margin-top:0px">
                        <div style="font-weight: bold;">Vendor</div>
                        <div style="margin-top:10px">
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd;">{{case.Vendor__c}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Category</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Product_Category__c}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Sub category</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Product_Sub_Category__c}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Product name</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Product_Name__c}}</p>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Product version</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Product_Version__c}}</p>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Operating system details</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-right-radius:0px; border-top-left-radius:0px">
                <div *ngIf="!isCaseLoaded" class="spinner-border text-info" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <div *ngIf="isCaseLoaded" class="row small-section-content">
                    <div class="col-xl-12 no-padding" style="margin-top:0px">
                        <div style="font-weight: bold;">Operating system vendor</div>
                        <div style="margin-top:10px">
                            <span style="margin: 0px; margin-top: 5px; font-size: 14px !important; color: #bdbdbd;">{{case.OS_Vendor__c}}</span>
                        </div>
                    </div>
                    <div class="col-xl-12 no-padding" style="margin-top:15px">
                        <div style="font-weight: bold;">Operating system</div>
                        <p style="margin: 0px;margin-top: 5px;font-size: 14px !important;color: #bdbdbd;">{{case.Operating_System_New__c}}</p>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>


